export default __webpack_public_path__ + "static/media/52.9c9083a1.jpg";